import React from "react";
import styles from "./Section2.module.scss";

export const Section2 = function () {
  return (
    <section className={`${styles.container} cc--component-container`}>
      <div className={styles.container_wrapper}>
        <aside className={styles.container_aside}>
          <picture className="s3-bucket-image" data-img-src="S3_bucket">
            <source
              media="(max-width: 767px)"
              srcSet="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_join_frontlines_m.jpg"
            />
            <source
              media="(min-width: 768px)"
              srcSet="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_join_frontlines.jpg"
            />
            <img
              decoding="async"
              loading="lazy"
              alt="Student at laptop"
              src="https://media.bootcampcdn.com/Columbia/landing/cyber/b5/img_join_frontlines.jpg"
            />
          </picture>
        </aside>
        <main className={styles.container_main}>
          <h2 className={styles.headline}>Join the Front Lines of Digital Defense</h2>
          <p>
            The economic impact of cyber crime is growing: In 2020, the average cost to businesses affected by a data
            breach in the United States was $8.64 million, up 32% from 2015, and nearly double the global average.
            <sup>1</sup>
          </p>
          <p>
            <strong>
              You can help protect organizations and populations — and change your entire career trajectory
            </strong>
            . As the world grows more connected and automated (and therefore, more vulnerable), the demand for
            cybersecurity specialists is on the rise. Information security is a fast-growing field,<sup>2</sup> and one
            of Glassdoor’s Top 50 Jobs in America for 2022.<sup>3</sup>
          </p>
          <p className={styles.footnote}>
            <sup>1</sup>
            <a
              href="https://www.statista.com/statistics/273575/average-organizational-cost-incurred-by-a-data-breach/"
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              Statista.com
            </a>
            <br />
            <sup>2</sup>
            <a
              href="https://www.bls.gov/ooh/computer-and-information-technology/information-security-analysts.htm"
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              Bureau of Labor Statistics
            </a>
            <br />
            <sup>3</sup>
            <a
              href="https://www.glassdoor.com/List/Best-Jobs-in-America-LST_KQ0,20.htm"
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              Glassdoor
            </a>
          </p>
        </main>
      </div>
    </section>
  );
};
